var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.setLocale(_vm.$i18n.locale  === 'en' ? 'fr' : 'en')}}},[_vm._v(_vm._s(_vm.$i18n.locale === 'en' ? 'Français' : 'English'))])}
var staticRenderFns = []

export { render, staticRenderFns }